import {
    cleanCommonParams,
    mapContentParams,
    mapFeedItemParams,
    mapImageParams,
    mapPlatformsParams,
    mapProductsParams,
    mapSalesChannelsParams,
    mapStatesParams,
    mapTagsParams,
} from './common';

const mapWebinarParams = (
    isCreate,
    {
        categories,
        content,
        feed_item,
        image,
        productCategories,
        platforms,
        products,
        sales_channels,
        salesAndMarketingCategories,
        search_phrase_ids,
        states,
        systemCategories,
        tags,
        ...params
    },
) => {
    return new Promise((resolve) => {
        const categoryIds = [].concat(
            productCategories,
            salesAndMarketingCategories,
            systemCategories,
        );

        resolve({
            webinar: {
                role_type: 'agent',
                ...cleanCommonParams(params),
                ...mapContentParams(isCreate, content),
                ...mapFeedItemParams(isCreate, feed_item),
                ...mapImageParams(isCreate, image),
                ...mapPlatformsParams(isCreate, platforms),
                ...mapProductsParams(isCreate, products),
                ...mapSalesChannelsParams(isCreate, sales_channels),
                ...mapStatesParams(isCreate, states),
                ...mapTagsParams(isCreate, tags),
                category_ids: categoryIds,
                search_phrase_ids: search_phrase_ids || [],
            },
        });
    });
};

export { mapWebinarParams };
